import { GzToastNotificationWebComponent } from '../../..';
import { GzToast, ToastPositionX, ToastPositionY, ToastSeverity } from '../../../ui/gzToastNotification/type';

interface CreateToastNotificationParams {
  message: string;
  severity?: ToastSeverity;
  actionButtonText?: string;
  actionCallback?: EventListenerOrEventListenerObject;
  hasAction?: boolean;
}

export class QuarantineToastNotification {
  static createToastNotification({
    message,
    severity = ToastSeverity.INFORMATIVE,
    actionButtonText,
    actionCallback,
    hasAction,
  }: CreateToastNotificationParams) {
    const toastNotificationConfigs: GzToast = {
      message,
      hasAction,
      severity,
      x: ToastPositionX.RIGHT,
      y: ToastPositionY.BOTTOM,
      autoCloseDelayMs: 10000,
      actionButtonText,
      actionCallback,
      showInlineButton: true,
    };

    GzToastNotificationWebComponent.buildToastWrapperElement(toastNotificationConfigs);
  }
}
